import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQAccordion() {
  const faqs = [{
    question: 'What is the Testbed Schools Initiative?',
    answer: 'The Testbed Schools Initiative is a partnership between your school and Eedi, where you use our platform to gather valuable insights and shape the future of maths education. Schools engage in additional mini-experiments, use Eedi consistently in the classroom, and provide feedback to help refine the platform.'
  }, {
    question: 'Who can join the initiative?',
    answer: 'We are looking for primary and secondary state schools in the United Kingdom or the United States with maths classes across multiple year groups. At least two teachers per year group must commit to using Eedi with all of their classes for the duration of the academic year.'
  }, {
    question: 'How much time does the initiative require?',
    answer: 'Participating schools should aim for regular, weekly Eedi usage in classrooms and for homework (quizzes take 20-30 minutes). Testbed schools must also administer STAR assessments three times a year (around 30 minutes each, during class time). Eedi will set up all students on the STAR platform. Time commitment for R&D pilots varies by project.'
  }, {
    question: "What's the financial commitment for schools?",
    answer: 'There is no cost to participate. In fact, schools receive financial incentives, including a £500 base award and additional rewards for participating in R&D pilots.'
  }, {
    question: 'What is the duration of the initiative?',
    answer: "The Testbed Schools Initiative is a one-year commitment, running from September to July. During this period, your school will engage with Eedi's platform, participate in R&D pilots, administer assessments, and provide valuable feedback to our research team."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-16">
      {faqs.map((faq, index) => <div key={index} className="border-b border-gray-200 last:border-b-0" data-id="element-17">
          <button className="flex justify-between items-center w-full px-6 py-4 text-left" onClick={() => toggleFAQ(index)} data-id="element-18">
            <h3 className="text-lg font-medium text-gray-900" data-id="element-19">
              {faq.question}
            </h3>
            <ChevronDownIcon className={`w-5 h-5 text-gray-500 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-20" />
          </button>
          <div className={`px-6 overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-21">
            <p className="text-gray-700" data-id="element-22">{faq.answer}</p>
          </div>
        </div>)}
    </div>;
}